export enum Currency {
  USD = 'USD',
  INR = 'INR',
  EUR = 'EUR',
  GBP = 'GBP',
  JPY = 'JPY',
  AUD = 'AUD',
  CAD = 'CAD',
  CNY = 'CNY',
}

export enum Locale {
  US = 'en-US',
  India = 'en-IN',
  Germany = 'de-DE',
  UK = 'en-GB',
  Japan = 'ja-JP',
  Australia = 'en-AU',
  Canada = 'en-CA',
  China = 'zh-CN',
}
export interface CurrencyFormatOptions {
  minimumFractionDigits?: number;
  maximumFractionDigits?: number;
  useAccountingFormat?: boolean;
}
export interface FormattedCurrency {
  formatted: string;
  symbol: string;
}
